<template lang='pug'>
  el-dialog.unistar-quotation-dialog(
    :visible='visible'
    :title="title"
    @close='closeDialog'
    width='900px'
    :close-on-click-modal='false'
    center
  )
    el-row(:gutter='20')
      el-col.title(:span='3') {{ $t('执行价目表') }}
      el-col(:span='21')
        el-table(
          v-loading='loading'
          :data='dataBack.quotation'
          max-height='215'
        )
          el-table-column(
            prop='star_service_id'
            align='left'
            :label='$t("服务类别")'
            min-width='160'
            :show-overflow-tooltip='viewMode'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              i.iconfont.icon-shanchu1(
                v-if="scope.$index !== 0"
                @click="delRow(scope)"
              )
              span(
                v-else
                style="width: 10px;display:inline-block;margin-left:8px"
              )
              span(v-if='viewMode' style='margin-left: 3px') {{ isZh ? scope.row.star_service_nameCh : scope.row.star_service_name }}
              el-select(
                v-else
                v-model='scope.row.star_service_id'
                :placeholder='$t("请选择类别")'
                size='mini'
                style='width: 110px; margin-left: 3px'
                @change='e => { handleServiceChange(e, scope.row) }'
              )
                el-option(
                  v-for="(o, i) in serviceList"
                  :key='i'
                  :label='isZh ? o.star_service_name_ch : o.star_service_name'
                  :value='o.star_service_id'
                )

          el-table-column(
            prop='star_service_item_name'
            :label='$t("服务项目")'
            align='left'
            min-width='140'
            :show-overflow-tooltip='viewMode'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ isZh ? scope.row.star_service_item_nameCh : scope.row.star_service_item_name }}
              template(v-else)
                el-select(
                  v-if='getServiceItemList(scope.row.star_service_id).length > 0'
                  v-model='scope.row.star_service_item_name'
                  placeholder=''
                  size='mini'
                  @change='v => handleServiceItemSelect(getServiceItemList(scope.row.star_service_id), scope.row)'
                )
                  el-option(
                    v-for='(o, index) in getServiceItemList(scope.row.star_service_id)'
                    :key='index'
                    :label='isZh ? o.service_item_name_ch : o.star_service_item_name'
                    :value='o.star_service_item_name'
                    :disabled="dataBack.quotation.map(i => i.star_service_item_id).includes(o.star_service_item_id)"
                  )
                el-input(
                  v-else
                  v-model='scope.row.star_service_item_name'
                  :maxlength='100'
                  :placeholder='$t("≤100字")'
                  @change='v => handleServiceItemInput(v, scope.row)'
                  :disabled='checkShouldDisabled(scope.row.is_asset)'
                )

          el-table-column(
            prop='unitPrice'
            :label='$t("单价")'
            align='left'
            min-width='150'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.unit_price | formatMoney }}
              vue-numeric(
                v-else
                v-model='scope.row.unit_price'
                :unit="$t('元')"
                :precision='2'
              )
          el-table-column(
            prop='number'
            :label='$t("数量")'
            align='left'
            min-width='100'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.number | numberWithCommas }}
              template(v-else)
                input-with-commas(
                  v-model='scope.row.number'
                  :disabled='checkShouldDisabled(scope.row.is_asset)'
                )
          el-table-column(
            width='150'
            align='right'
          )
            template(slot-scope='scope')
              span {{ getTotalPrice(scope.row) | formatMoney }}
        .table-footer
          el-button(
            v-if='!viewMode'
            type='text'
            @click='addRow'
          ) + {{ $t("添加报价") }}
          .total_price
            .discount
              span {{ $t('折扣') }}(-)：
              vue-numeric(
                style="width: 120px"
                v-model='dataBack.discount'
                :unit="$t('元')"
                :precision='2'
              )
            .discount
              span {{ $t('小计') }}：
              .vue-numeric(
                style="width: 120px"
              ) {{ totalPrice }}
    .dialog-footer(slot="footer")
      el-button(
        @click='handleConfirm'
        type="primary"
      ) {{ $t('确定') }}
      el-button(
        @click='$emit("close")'
        type="plain"
      ) {{ $t('取消') }}
</template>

<script>
import axios from 'axios'
import { numberWithPercent, formatMoney, numberWithCommas, formatDate } from '@/umcc/util'
// import dayjs from 'dayjs'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import InputWithCommas from '@/components/InputWithCommas'
import db from '@/umcc/db'
// import accounting from 'accounting-js'
import VueNumeric from '@/components/VueNumeric'
import TitleBar from '@/components/TitleBar'
import { cloneDeep } from 'lodash'

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default () {
        return {
          total_price: null,
          quotation: [
            {
              number: null,
              star_id: null,
              star_service_name: '',
              star_service_id: null,
              total_price: null,
              star_service_item_id: null,
              unit_price: null,
              star_service_item_name: ''
            }
          ],
          tax_price: null
        }
      }
    }
  },
  data () {
    return {
      loading: false,
      serviceList: [],
      kolTemplateUrl: null,
      hasKolBuying: true,
      KolFailReport: null,
      dataBack: {
        quotation: []
      }
    }
  },
  computed: {
    isZh () {
      return db.lang === 'zh'
    },
    totalPrice () {
      let arr = this.dataBack.quotation.filter(d => d.total_price)
      if (arr.length) {
        let num = arr.map(d => d.total_price).reduce((a, b) => a + b) - this.dataBack.discount
        return isNaN(num) ? '-' : formatMoney(num)
      } else {
        return '—'
      }
    }
  },
  mounted () {
    this.fetchServiceList()
    this.dataBack = cloneDeep(this.data)
    if (!this.dataBack.quotation.length) {
      this.dataBack.quotation = [
        {
          number: null,
          star_id: null,
          star_service_name: '',
          star_service_id: null,
          total_price: null,
          star_service_item_id: null,
          unit_price: null,
          star_service_item_name: ''
        }
      ]
    }
  },
  filters: {
    formatMoney,
    numberWithCommas,
    numberWithPercent,
    formatDate
  },
  methods: {
    checkShouldDisabled (isAsset) {
      return this.hasSync && this.checkIsAsset && isAsset === 1
    },
    renderHeader (h, { column, $index }) {
      return <span class='required'>
        { column.label }
      </span>
    },
    handleServiceChange (id, row) {
      // 重置项目及单价
      row.unit_price = 0
      row.star_service_item_name = ''
      row.star_service_name = this.isZh ? this.serviceList.find(s => s.star_service_id === id).star_service_name_ch : this.serviceList.find(s => s.star_service_id === id).star_service_name
    },
    getServiceItemList (id) {
      const list = this.serviceList.find(i => i.star_service_id === id)
      if (!list) return []
      return list.children
    },
    async fetchServiceList () {
      this.loading = true
      const res = await axios.get('/management/star/getStarExecutionServiceList')
      const serviceItemList = await Promise.all(res.map(item => axios.get('/management/star/getStarServiceItemList', {
        params: { star_service_id: item.star_service_id }
      })))
      this.serviceList = res.map((item, index) => {
        item.children = serviceItemList[index]
        return item
      })
      this.loading = false
    },
    delRow (scope) {
      this.dataBack.quotation.splice(scope.$index, 1)
    },
    getTotalPrice (row) {
      row.total_price = row.unit_price * row.number
      return row.total_price
    },
    addRow () {
      this.dataBack.quotation.push(
        {
          'star_service_id': null,
          'total_price': null,
          'star_service_name': '',
          'star_service_item_id': null,
          'unit_price': null,
          'star_service_item_name': ''
        }
      )
    },
    handleServiceItemSelect (list, row) {
      row.star_service_item_id = list.find(o => o.star_service_item_name === row.star_service_item_name).star_service_item_name === '3rd party cost' ? '' : list.find(o => o.star_service_item_name === row.star_service_item_name).star_service_item_id
    },
    handleServiceItemInput (servive, row) {
      row.star_service_item_id = ''
      row.unitPrice = 0
    },
    async validator () {
      const res = []

      this.dataBack.quotation.forEach(item => {
        if (!item.star_service_id || !item.star_service_item_name || !item.unit_price) {
          res.push(this.$t('请填写必填项'))
        }

        if (!Number.isInteger(item.number) || item.number < 0) {
          res.push(this.$t('数量格式不正确'))
        }
      })

      if (this.dataBack.quotation.filter(d => d.total_price).length && this.dataBack.quotation.filter(d => d.total_price).map(d => d.total_price).reduce((a, b) => a + b) - this.dataBack.discount >= 1000000000) {
        res.push(this.$t('总价格超出最大限制'))
      }

      if (res.length > 0) {
        this.$message.error(res[0])
        return false
      }

      return true
    },
    async handleConfirm () {
      if (this.viewMode) {
        this.$emit('close')
        return
      }
      if (!await this.validator()) return
      this.dataBack.total_price = this.dataBack.quotation.map(o => o.total_price).reduce((a, b) => a + b)
      this.dataBack.tax_price = (this.dataBack.total_price - this.dataBack.discount) * 0.06
      this.dataBack.tax_total_price = this.dataBack.total_price + this.dataBack.tax_price - this.dataBack.discount
      this.$emit('confirm', this.dataBack)
    },
    closeDialog () {
      this.$emit('close')
    }
  },
  components: {
    UploadMultipleFile,
    NewUploadFile,
    UploadedFileDisplay,
    InputWithCommas,
    VueNumeric,
    TitleBar
  }
}
</script>

<style lang='stylus'>
$border = solid 1px #979797
.unistar-quotation-dialog
  .table-footer
    align-items flex-start
</style>
